import React from "react";
import PropTypes from "prop-types";
import Check from "rialto-icons/Check";
import SearchWhite from "rialto-icons/SearchWhite";
import SelectAll from "rialto-icons/SelectAll";

import Translate from "utils/translate";

import styles from "./SearchBlock.css";

const { t } = new Translate("SearchBlock");

const SearchBlock = ({
  isAllSelected,
  keywords,
  nbSelectedPortfolios,
  onApply,
  onSearch,
  onSelectAll,
  onUnselectAll,
}) => (
  <div className={styles.root}>
    <div className={styles.background} />
    <div className={styles.content}>
      <div className={styles.search}>
        <SearchWhite />
        <input
          autoComplete="off"
          name="keywords"
          onChange={(e) => onSearch(e.target.value)}
          placeholder={t("searchPortfolios")}
          value={keywords}
        />
      </div>
      <button onClick={isAllSelected ? onUnselectAll : onSelectAll} type="button">
        <SelectAll />
        {isAllSelected ? t("unselectAll") : t("selectAll")}
      </button>
      <div className={styles.apply}>
        <button onClick={onApply} type="submit">
          <Check />
        </button>
        <div>{nbSelectedPortfolios}</div>
      </div>
    </div>
  </div>
);

SearchBlock.propTypes = {
  keywords: PropTypes.string,
  isAllSelected: PropTypes.bool,
  onApply: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onUnselectAll: PropTypes.func.isRequired,
  nbSelectedPortfolios: PropTypes.number,
};

export default SearchBlock;
